"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GlobeAmericasIcon = require("./GlobeAmericasIcon");

var _GlobeAmericasIcon2 = _interopRequireDefault(_GlobeAmericasIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _GlobeAmericasIcon2.default;